module.exports = __webpack_public_path__ + "media/images/file-icons/512/005-database-6f8a50cd5da1402c38c5c24d9d8c7ef7.png";